import * as React from "react";
// @ts-ignore
import Script from "react-load-script";
import { connect } from "react-redux";
import { IGooglePlace } from "shared/model/ICoworkGeoLocation";
import { throttle } from "throttle-debounce";

import GooglePlacesClient from "../../../../services/Google/GooglePlacesClient";
import { IState } from "../../../../state/modules";
import CommonBotSelectors from "../../../../state/modules/commonBot/CommonBotSelectors";
import { Dispatch } from "../../../../state/store/store";
import PlacesAutoComplete from "./PlacesAutoComplete";

const SEARCH_THROTTLE_MS = 500;

interface IProps {
  autoComplete?: IGooglePlace[];
  fetchLocationsAutoComplete?: (props: { query: string, generalSearch?:boolean }) => void;
  className?: string;
  setPlacesAutoComplete?: (props: { places: IGooglePlace[] }) => void;
  setSelectedPlace?: (props: { place: IGooglePlace | string }) => void;
  onPlaceSelected: (place: IGooglePlace | string) => void;
  autoFocus?: boolean
  navigationProperty?: string;
  updateStore?:(val: string) => void;
  generalSearch? : boolean;
  initialValue?: string;
  inputLabel: string;
  placeholder: string
}

interface ILocalState {
  scriptLoaded: boolean;
  searchQuery: string;
}

@(connect(
  (state: IState, ownProps: IProps): Partial<IProps> => ({
    autoComplete: CommonBotSelectors.placesAutocomplete(state.commonBot),
    fetchLocationsAutoComplete: Dispatch.commonBot.fetchLocationsAutoComplete,
    setPlacesAutoComplete: Dispatch.commonBot.setPlacesAutocomplete,
    setSelectedPlace: Dispatch.commonBot.setSelectedPlace
  })
) as any)
export default class PlacesAutoCompleteContainer extends React.Component<
  IProps,
  ILocalState
> {
  public state: ILocalState = {
    scriptLoaded: false,
    searchQuery: ""
  };

  private throttledOnFetchRequested = throttle(
    SEARCH_THROTTLE_MS,
    false,
    (query: string) => {
      const { fetchLocationsAutoComplete, generalSearch } = this.props;
      fetchLocationsAutoComplete!({ query, generalSearch });
    }
  );

  constructor (props: IProps) {
    super(props);
    const initilizedValue = props.initialValue;
    this.state = {
      scriptLoaded: false,
      searchQuery: initilizedValue || ""
    };
  }

  public render() {
    const { autoComplete, className, autoFocus, navigationProperty, inputLabel, placeholder } = this.props;
    const { searchQuery } = this.state;
    return (
      <div className={className}>
        <Script
          url={GooglePlacesClient.scriptUrl}
          onError={this.onScriptError}
          onLoad={this.onScriptLoaded}
        />
        <div id={GooglePlacesClient.divId} />
        <PlacesAutoComplete
            onClearRequested={this.onClearRequested}
            placeHolder={placeholder}
            inputLabel={inputLabel}
            navigationProperty={navigationProperty}
            autoComplete={autoComplete!}
            autoFocus={autoFocus}
            onPlaceSelected={this.onPlaceSelected}
            searchQuery={searchQuery}
            onFreeTextSelected={this.onFreeTextSelected}
            onFetchRequested={this.throttledOnFetchRequested as any}
            onChange={this.onChange}
        />
      </div>
    );
  }


  private onPlaceSelected = (place: IGooglePlace) => {
    const { setSelectedPlace, onPlaceSelected } = this.props;
    setSelectedPlace!({ place });
    onPlaceSelected(place);
  };

  private onClearRequested = () => {
    return true;
  };

  private onFreeTextSelected = (place: string) => {
    if (place.length > 0) {
      const { setSelectedPlace, onPlaceSelected } = this.props;
      setSelectedPlace!({ place });
      onPlaceSelected(place);
    }
  };

  private onScriptError() {
    console.error("There was an issue loading the google maps script");
  }

  private onScriptLoaded = () => {
    this.setState({ scriptLoaded: true });
  };

  private onChange = (searchQuery: string) => {
    const {updateStore} = this.props;
    const newState = this.state;
    newState.searchQuery = searchQuery;
    this.setState(newState);
    if(updateStore) {
      updateStore(this.state.searchQuery);
    }
  };
}



// WEBPACK FOOTER //
// ./src/scenes/Bots/Common/PlacesAutoComplete/PlacesAutoCompleteContainer.tsx